// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/frontend/sass/app.scss
// module id = ./resources/assets/frontend/sass/app.scss
// module chunks = 1